import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddSignalRegistrationComponent } from '../modals/add-signal-registration/add-signalRegistration.component';
import { RegisterSignalClient, RegisteredSignal, SignalStatus, SignalStatusClient, UserProfessionClient, UserProfile, WorkingGroupClient, WorkingGroups } from 'src/app/web-api-client';
import { Observable, Subject, Subscription, forkJoin, publish } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { SignalFilter } from '../../models/signal-filter.model';
import { SignalStatusTypes } from '../../enums/signal-status.enum';
import { EmployeeService } from 'src/app/services/employee.service';
import { WtStorageService } from 'src/app/wt-storage.service';
import { UserProfessionTypes } from '../../enums/user-professions.enum';
import Swal from 'sweetalert2'
import { GridMapId } from '../../types/grid-map-id.type';
import { DataLayoutToggle } from '../../interfaces/data-layout-toggle.interface';
import { SignalFilterFormComponent } from './signal-filter-form/signal-filter-form.component';
import { Router } from '@angular/router';
import { SignalDetailsComponent } from '../modals/signal-details/signal-details.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-signals-registration-list',
  templateUrl: './signals-registration-list.component.html',
  styleUrls: ['./signals-registration-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignalsRegistrationListComponent implements OnInit, OnDestroy {

  @Input() isHeadless: boolean = false;
  @Input() isDashboardView: boolean = false;
  @Output() isTableRefreshed: Subject<boolean>= new Subject();

  public isLoading = false;

  public userProfile: UserProfile;
  public userProfessionTypes = UserProfessionTypes;
  public signalStatusTypes = SignalStatusTypes;

  public readonly gridColsNum = 11;

  public registeredSignalsMapView = new Map<number, RegisteredSignal>();
  public selectedRegisteredSignal: RegisteredSignal;
  public registeredSignalsList: RegisteredSignal[] = [];
  public filteredRegisteredSignalsList: RegisteredSignal[] = [];

  public signalStatusesList: SignalStatus[] = [];
  public wgroups: WorkingGroups[] = [];

  /** Indicator if the filters form is visible/hidden */
  public searchFiltersToggled = false;

  /** Current applied filters */
  public signalsSearchFilter: SignalFilter;

  public viewToggleOptions: DataLayoutToggle[] = [
    { id: 'grid', value: 'Таблица' },
    { id: 'map', value: 'Карта' }
  ];
  public currentlySelectedView: DataLayoutToggle = this.viewToggleOptions[0];

  private swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger',
    },
    buttonsStyling: false,
  });

  private subscriptions = new Subscription();

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly registerSignalService: RegisterSignalClient,
    private readonly workingGroupClient: WorkingGroupClient,
    private readonly signalStatusService: SignalStatusClient,
    private readonly employeeService: EmployeeService,
    private readonly userProfessionService: UserProfessionClient,
    private readonly localStorage: WtStorageService,
    private toastr: ToastrService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.userProfile = this.localStorage.getuser();
    console.log("userProfile working group", this.userProfile.workingGroups);
    if (this.isDashboardView) {
      this.loadMyData();
    }
    else {
      this.loadData();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public get isGridView(): boolean {
    return this.currentlySelectedView.id === 'grid';
  }

  public get isMapView(): boolean {
    return this.currentlySelectedView.id === 'map';
  }

  public get isUserTechnicalManager(): boolean {
    return this.userProfile.userProfessionIdUserProfession === UserProfessionTypes.TECHNICAL_MANAGER;
  }

  public get isUserDispatcher(): boolean {
    return this.userProfile.userProfessionIdUserProfession === UserProfessionTypes.DISPATCHER;
  }

  public get isUserRepairGroupManager(): boolean {
    return this.userProfile.userProfessionIdUserProfession === UserProfessionTypes.REPAIR_GROUP_MANAGER;
  }

  public isSignalClosed(registeredSignal: RegisteredSignal): boolean {
    const r = registeredSignal;

    return r.signalStatusId === SignalStatusTypes.CLOSED_ISSUE_IDENTIFIED ||
      r.signalStatusId === SignalStatusTypes.CLOSED_ISSUE_NOT_IDENTIFIED;
  }

  public isSignalFalse(registeredSignal: RegisteredSignal): boolean {
    return registeredSignal.signalStatusId === SignalStatusTypes.FALSE_ALARM;
  }

  public isEditingAllowed(registeredSignal: RegisteredSignal): boolean {
    if (this.isSignalClosed(registeredSignal) || this.isSignalFalse(registeredSignal)) {
      return false;
    }

    if (this.isUserDispatcher) {
      return registeredSignal.signalStatusId === SignalStatusTypes.ACCEPTED;
    }

    if (this.isUserTechnicalManager) {
      return registeredSignal.signalStatusId === SignalStatusTypes.PROCESSING;
    }

    if (this.isUserRepairGroupManager) {
      return false;
    }

    return true;
  }

  public isSignalProcessBtnVisible(registeredSignal: RegisteredSignal): boolean {
    if (this.isUserTechnicalManager) {
      return registeredSignal.signalStatusId === SignalStatusTypes.ACCEPTED;
    }

    return false;
  }

  public isSignalCheckUpBtnVisible(rs: RegisteredSignal) {
    if (this.isUserRepairGroupManager) {
      let isProcessing = rs.signalStatusId === this.signalStatusTypes.PROCESSING;
      let isOwner = false;

      if (rs.workingGroups?.manager) {
        isOwner = rs.workingGroups.id == this.userProfile.idWorkingGroups;
      }

      return isProcessing && isOwner;
    }

    return false;
  }

  public isSignalFinalizeBtnVisible(rs: RegisteredSignal) {
    if (this.isUserRepairGroupManager) {
      let isChecking = rs.signalStatusId === this.signalStatusTypes.CHECKING;
      let isOwner = false;

      if (rs.workingGroups?.manager) {
        isOwner = rs.workingGroups.id == this.userProfile.idWorkingGroups;
      }

      return isChecking && isOwner;
    }

    return false;
  }


  public onRefresh(): void {

    if (this.isGridView) {
      this.loadMyData();
    }
    else {
      this.loadData();
    }

    this.isTableRefreshed.next(true);
  }

  public onAddNewSignalClicked() {
    const modalRef = this.modalService.open(AddSignalRegistrationComponent, { size: 'xl', centered: true });
    const componentInstance = <AddSignalRegistrationComponent>modalRef.componentInstance;


    this.subscriptions.add(
      componentInstance.onSignalAdded.subscribe(registeredSignal => {

        this.toastr.success("Успешно добавяне", "Добавяне на Сигнал", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.resetSignalsSearchFilter();
        if (this.isGridView) {
          this.loadMyData();
        }
        else {
          this.loadData();
        }
      })
    );
  }

  public onToggleMapView(registeredSignal: RegisteredSignal) {
    if (this.isLocationMapView(registeredSignal)) {
      this.registeredSignalsMapView.delete(registeredSignal.id);
    } else {
      this.registeredSignalsMapView.set(registeredSignal.id, registeredSignal);
    }

    this.changeDetectorRef.detectChanges();
  }

  public isLocationMapView(registeredSignal: RegisteredSignal) {
    return this.registeredSignalsMapView.has(registeredSignal.id);
  }

  public onViewChange($event: DataLayoutToggle) {
    this.currentlySelectedView = $event;
  }

  public onGridRowSelected(registeredSignal: RegisteredSignal) {
    this.selectedRegisteredSignal = this.isGridRowSelected(registeredSignal)
      ? null
      : registeredSignal;
  }

  public isGridRowSelected(registeredSignal: RegisteredSignal): boolean {
    return this.selectedRegisteredSignal == registeredSignal;
  }

  public getZachislenSignal(registeredSignal: RegisteredSignal): string {

    if (!registeredSignal.workingGroups)
      return ' ';

    let manager = '';
    if (registeredSignal.workingGroups.manager) {

      manager = ` (${registeredSignal.workingGroups.manager.firstName} ${registeredSignal.workingGroups.manager.fammilyName})`
    }

    return `${registeredSignal.workingGroups.title}${manager}`;
  }

  public getDispecherNames(registeredSignal: RegisteredSignal): string {
    const employee = registeredSignal.dispecherEmployee;
    if (!employee) {
      return 'n/a';
    }

    const nameBuilder = [];
    if (employee.firstName) {
      nameBuilder.push(employee.firstName);
    }

    if (employee.fammilyName) {
      nameBuilder.push(employee.fammilyName);
    }

    return nameBuilder.join(' ');
  }

  public getSignalRequestorNames(registeredSignal: RegisteredSignal): string {
    const signalRequestor = registeredSignal.signalRequestor;
    if (!signalRequestor) {
      return 'n/a';
    }

    const nameBuilder = [];
    if (signalRequestor.name) {
      nameBuilder.push(signalRequestor.name);
    }
    if (signalRequestor.middleName) {
      nameBuilder.push(signalRequestor.middleName);
    }
    if (signalRequestor.fammily) {
      nameBuilder.push(signalRequestor.fammily);
    }

    return nameBuilder.join(' ');
  }

  public toggleSearchFilters() {
    this.searchFiltersToggled = !this.searchFiltersToggled;
    this.changeDetectorRef.detectChanges();
  }

  public onSignalDeletion(item: RegisteredSignal) {
    Swal.fire({
      title: "",
      text: `Сигурни ли сте, че искате да изтриете Сигнал ${item.title}?`,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Да",
      cancelButtonText: "Не сега",
    }).then((result) => {

      if (result.isConfirmed) {
        this.registerSignalService.remove(item.id).subscribe(r => {
          if (this.isDashboardView) {
            this.loadMyData();
          }
          else {
            this.loadData();
          }

        });
      }
    });

    //  .then((result) => {
    //  if (result.isConfirmed) {

    //    this.registerSignalService.remove(item.id).subscribe(r => {

    //    })
    //  });
    //  }
    //);
  }

  public onSignalEditClicked($event: RegisteredSignal) {
    this.openSignalViewModal($event);
  }

  public onSignalProcessClicked($event: RegisteredSignal) {
    const signalStatus: SignalStatusTypes = $event.signalStatusId;
    if (this.isUserTechnicalManager && signalStatus === SignalStatusTypes.ACCEPTED) {
      this.processSignal($event);
      return;
    }
  }

  /**
   * This is called by user with status Repair Group manager ONLY.
   *
   * @param $event
   * @returns
   */
  public onSignalCheckProceedClicked($event: RegisteredSignal) {
    if (!this.isUserRepairGroupManager) {
      return;
    }

    this.openSignalViewModal($event);
  }

  /**
   * This is called by user with sttatus Repair Group Manager ONLY
   * and for signals with status CHECKING!!!
   *
   * @param $event
   * @returns
   */
  public onSignalFinalizeClicked($event: RegisteredSignal) {
    if (!this.isUserRepairGroupManager) {
      return;
    }


    $event.closeEmployeeId = this.userProfile.id;
    $event.closeDate = new Date();

    this.openSignalViewModal($event);
  }

  private processSignal($event: RegisteredSignal) {
    if (!this.isUserTechnicalManager) {
      return;
    }

    this.swalWithBootstrapButtons
      .fire({
        title: `${$event.title}`,
        text: `Сигурни ли сте, че искате да започнете обработка на сигнала?`,
        showCancelButton: true,
        confirmButtonText: 'Да',
        cancelButtonText: 'Отказ',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
          try {
            const newObj = Object.assign({}, $event);
            newObj.signalStatusId = SignalStatusTypes.PROCESSING;
            const result = await this.getSignalStatusUpdateAsPromise(newObj);
            if (result) {
              const signalStatusTitle = this.signalStatusesList.find(s => s.id === newObj.signalStatusId)?.title;
              const signalStatusObj = new SignalStatus();
              signalStatusObj.id = newObj.signalStatusId;
              signalStatusObj.title = signalStatusTitle;
              newObj.signalStatus = signalStatusObj;

              const index = this.registeredSignalsList.findIndex(s => s.id === $event.id);
              if (index > -1) {
                this.registeredSignalsList[index] = newObj; console.log(this.registeredSignalsList);
                this.filteredRegisteredSignalsList = this.filteredRegisteredSignalsList.slice(); console.log(this.filteredRegisteredSignalsList);
                this.changeDetectorRef.detectChanges();
              }
            }

            return result;
          } catch (err) {
            return false;
          }
        }
      })
      .then((result: any) => {
        if (result.isConfirmed && result.value) {
          const updatedSignal = this.registeredSignalsList.find(s => s.id === $event.id);
          this.openSignalViewModal(updatedSignal);
        }
      });
  }

  /**
   * Filters the array of registered signals based on a search criteria.
   *
   * @param signalsSearchFilter the search criteria.
   */
  public onFilterSignalsList(signalsSearchFilter: SignalFilter) {
    this.signalsSearchFilter = signalsSearchFilter;
    this.FilterData();
    this.changeDetectorRef.detectChanges();
  }

  public onClearFiltersClicked() {
    this.resetSignalsSearchFilter();
    this.changeDetectorRef.detectChanges();
  }

  private loadData() {
    this.isLoading = true;

    let regSignals: RegisteredSignal[] = [];
    this.registerSignalService.getList().subscribe(list => {

      regSignals = list.slice();

      forkJoin([
        this.signalStatusService.getList(),
        this.workingGroupClient.getList(),
        this.userProfessionService.getList()
      ]).subscribe(([signalStatusesList, wgroups, userProfessionsList]) => {
        this.wgroups = wgroups;

        /*regSignals.sort((a, b) => b.id - a.id);*/
        regSignals.sort((a, b) => {
          // Assuming 'when' is a date string, convert to Date objects for comparison
          // For direct Date objects comparison, simply use: new Date(b.when) - new Date(a.when);
          return new Date(b.when).getTime() - new Date(a.when).getTime();
        });

        this.registeredSignalsList = regSignals;

        this.filteredRegisteredSignalsList = this.registeredSignalsList;
        this.signalStatusesList = signalStatusesList;

        this.FilterData();


        this.isLoading = false;
        this.changeDetectorRef.detectChanges();

      })
    })


  }

  private FilterData() {
        if (!!this.signalsSearchFilter) {
            this.filteredRegisteredSignalsList = this.registeredSignalsList.filter(rs => {
                const startDateFlag = this.signalsSearchFilter.startDate
                    ? rs.when.getTime() >= this.signalsSearchFilter.startDate.getTime()
                    : true;

                const endDateFlag = this.signalsSearchFilter.endDate
                    ? rs.when.getTime() <= this.signalsSearchFilter.endDate.getTime()
                    : true;

                const statusFlag = this.signalsSearchFilter.signalStatusType
                    ? rs.signalStatus.id === this.signalsSearchFilter.signalStatusType
                    : true;

                return startDateFlag && endDateFlag && statusFlag;
            });
        }
    }

  private loadMyData() {
    this.isLoading = true;

    let regSignals: RegisteredSignal[] = [];
    this.registerSignalService.getMyList().subscribe(list => {

      regSignals = list.slice();

      forkJoin([
        this.signalStatusService.getList(),
        this.workingGroupClient.getList(),
        this.userProfessionService.getList()
      ]).subscribe(([signalStatusesList, wgroups, userProfessionsList]) => {
        this.wgroups = wgroups;

        /*regSignals.sort((a, b) => b.id - a.id);*/
        regSignals.sort((a, b) => {
          // Assuming 'when' is a date string, convert to Date objects for comparison
          // For direct Date objects comparison, simply use: new Date(b.when) - new Date(a.when);
          return new Date(b.when).getTime() - new Date(a.when).getTime();
        });

        this.registeredSignalsList = regSignals;

        this.filteredRegisteredSignalsList = this.registeredSignalsList;
        this.signalStatusesList = signalStatusesList;

        this.isLoading = false;
        this.changeDetectorRef.detectChanges();

      })
    })


  }

  private updateSignalStatusAndGetObservable(registeredSignal: RegisteredSignal): Observable<boolean> {
    return this.registerSignalService.update(registeredSignal);
  }

  private getSignalStatusUpdateAsPromise(registeredSignal: RegisteredSignal): Promise<boolean> {



    if (registeredSignal.checkoutWhen) {
      const checkoutDate = new Date(registeredSignal.checkoutWhen);
      if (checkoutDate.getFullYear() === 1) {
        // If year is 0000, then set to "0001-01-01T01:01:00.000Z"
        registeredSignal.checkoutWhen = new Date("0001-01-01T01:01:00.000Z");
      }
    }


    return new Promise((resolve, reject) => {
      this.updateSignalStatusAndGetObservable(registeredSignal).subscribe(res => {
        resolve(res);
      })
    });
  }

  /**
   * View/edit of a registered signal.
   * @param $event
   */
  private openSignalViewModal($event: RegisteredSignal) {
    const modalOptions: NgbModalOptions = { size: 'xl', centered: true };
    const modalRef = this.modalService.open(AddSignalRegistrationComponent, modalOptions);
    const componentInstance = <AddSignalRegistrationComponent>modalRef.componentInstance;
    componentInstance.registeredSignal = $event;

    modalRef.dismissed.subscribe(() => {
      console.log('dismissed');
    });


    this.subscriptions.add(
      componentInstance.onSignalUpdated.subscribe(updatedSignal => {

        this.toastr.success("Успешно редактиран Сигнал", "Добавяне на Сигнал", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.onSignalUpdated(updatedSignal);
        this.changeDetectorRef.detectChanges();
      })
    );
  }

  public openReadOnlySignalViewModal($event: RegisteredSignal) {
    const modalOptions: NgbModalOptions = { size: 'xl', centered: true };
    const modalRef = this.modalService.open(SignalDetailsComponent, modalOptions);
    const componentInstance = <SignalDetailsComponent>modalRef.componentInstance;
    componentInstance.registeredSignal = $event;


    modalRef.dismissed.subscribe(() => {
      console.log('dismissed');
    });


  }

  private onSignalUpdated(updatedSignal: RegisteredSignal) {
    const index = this.registeredSignalsList.findIndex(s => s.id === updatedSignal.id);
    if (index > -1) {
      this.registeredSignalsList[index] = updatedSignal;
      this.registeredSignalsList = this.registeredSignalsList.slice();
      this.filteredRegisteredSignalsList = this.filteredRegisteredSignalsList.slice();

      if (updatedSignal.signalStatusId === SignalStatusTypes.CLOSED_ISSUE_IDENTIFIED) {
        this.confirmEmergencyAddForSignal(updatedSignal);
      }
    }
  }

  private resetSignalsSearchFilter() {
    this.filteredRegisteredSignalsList = this.registeredSignalsList;
    this.signalsSearchFilter = null;
  }

  private confirmEmergencyAddForSignal(signal: RegisteredSignal) {
    Swal.fire({
      title: "",
      text: "Искате ли да създадетe авария за този сигнал?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Да",
      cancelButtonText: "Не сега",
    }).then((result) => {
      if (result.isConfirmed) {
        //this.router.navigate([`/emergencies/`, {signalId: signal.id }]);
        this.router.navigateByUrl('/emergencies', {
          state: {
            signalId: signal.id
          }
        });
      }
    });
  }
}
